import React from 'react'
import { Box } from '@chakra-ui/react'
import { Radio } from '@chakra-ui/react'
import { Collapse } from '@chakra-ui/react'

import SharedLabel from '~components/shared/form/shared-label'
import SharedInfoText from '~components/shared/texts/shared-info-text'
import OutlineBox from '~components/shared/wrappers/outline-box'
import SharedStack from './shared-stack'
import { BoxProps, Spacer } from '@chakra-ui/react'

interface Props extends BoxProps {
    isSelected: boolean
    onClick: () => void
    label: string
    helpText?: string
    leftFlair?: React.ReactNode
    configComponent?: React.ReactNode
    /**
     * Overrides the trailing radio select (e.g. a chevron for options that
     * navigate to a subpage instead of selecting a value).
     */
    rightFlair?: React.ReactNode
}

export default function SharedSelectableOption({
    isSelected,
    onClick,
    label,
    helpText,
    leftFlair,
    configComponent,
    rightFlair,
    ...props
}: Props) {
    return (
        <OutlineBox
            w="full"
            shadow="none"
            cursor="pointer"
            onClick={onClick}
            _hover={{ bg: isSelected ? 'brand.100' : 'gray.50' }}
            bg={isSelected ? 'brand.50' : 'white'}
            borderColor={isSelected ? 'brand.500' : 'blackAlpha.200'}
            {...props}
        >
            <SharedStack gap={0} row alignItems="center">
                {leftFlair && leftFlair}
                <Box>
                    <SharedLabel fontSize="sm">{label}</SharedLabel>
                    {helpText && (
                        <SharedInfoText fontSize="xs" color="gray.500" mt={1}>
                            {helpText}
                        </SharedInfoText>
                    )}
                </Box>
                <Spacer />
                {rightFlair ?? (
                    <Radio isChecked={isSelected} colorScheme="brand" pl={2} />
                )}
            </SharedStack>
            {configComponent && (
                <Box as={Collapse} in={isSelected}>
                    {configComponent}
                </Box>
            )}
        </OutlineBox>
    )
}
